import { ApiTypes, StateRecord } from '@mode/shared/contract-common';

export interface PdfExportResource extends StateRecord, ApiTypes.ModeResource {
  content_length: number;
  created_at: string;
  filename: string;
  stale: boolean;
  state: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace PdfExportHelpers {
  export function reportHasBeenExportedToPdf(pdfExport: PdfExportResource) {
    return !!(pdfExport && pdfExport.state === 'completed');
  }
}
